import React, { useEffect, useState } from 'react';
import { makeStyles, MenuItem, Select, CircularProgress } from '@material-ui/core';
import { PropTypes } from 'prop-types';
const styles = makeStyles({
    rootSelect: {
        width: '100%',
        paddingRight: '13px',
        display: 'block'
    },
    select: {
        padding: '0 24px 0 0!important',
        borderBottom: 'solid 0.5px #bbbbbb',
        fontFamily: 'mainFont',
        whiteSpace: 'normal',
        borderRadius: 0,
        '&:focus': {
            backgroundColor: 'white',
            borderRadius: '0'
        }
    },
    menuItemRoot: {
        textAlign: 'left',
        direction: 'ltr',
        fontFamily: 'mainFont',
        color: '#767676'
    },
    input: {
        paddingRight: '13px'
    }
});
const FormSelect = ({
    options = [],
    value = '',
    loading,
    handleSelect,
    disabled,
    prevField,
    disableAutoOpen,
    dataTestId
}) => {
    const classes = styles();
    const [open, setOpen] = useState(false);
    const [prevDrug, setPrevDrug] = useState();
    useEffect(() => {
        if (prevField && prevField !== prevDrug && !disableAutoOpen) {
            setOpen(true);
            setPrevDrug(prevField);
        } else {
            setOpen(false);
        }
    }, [prevField]);
    return (
        <Select
            classes={{
                select: classes.select,
                root: classes.rootSelect,
                nativeInput: classes.input
            }}
            value={value}
            inputProps={{ 'data-testid': `${dataTestId}` }}
            disabled={options?.length === 0 || disabled}
            onChange={handleSelect}
            IconComponent={() => {
                if (loading) {
                    return <CircularProgress />;
                } else {
                    return null;
                }
            }}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
        >
            {options.map((item) => (
                <MenuItem classes={{ root: classes.menuItemRoot }} key={item.id} value={item.id}>
                    {item.name}
                </MenuItem>
            ))}
        </Select>
    );
};
FormSelect.propTypes = {
    options: PropTypes.array,
    value: PropTypes.string,
    loading: PropTypes.bool,
    handleSelect: PropTypes.func,
    disabled: PropTypes.bool,
    prevField: PropTypes.string,
    drugEdited: PropTypes.bool,
    disableAutoOpen: PropTypes.bool,
    dataTestId: PropTypes.string
};
export default FormSelect;
